import { action, makeObservable } from 'mobx';
import ApiStore from './ApiStore';
import AuthStore from './AuthStore';
import BusinessDashboardStore from './BusinessDashboardStore';
import ItemStore from './ItemStore';
import LandmarkStore from './LandmarkStore';
// MEO Phase 1 Sprint 2-F (2026-05-13)
import LandmarkNeighborhoodsStore from './LandmarkNeighborhoodsStore';
import LibraryStore from './LibraryStore';
import ModalStore from './ModalStore';
import OmikujiTextStore from './OmikujiTextStore';
import SettingStore from './SettingStore';
import UIStore from './UIStore';
import UserEventsAdminStore from './UserEventsAdminStore';
import UserStore from './UserStore';
// T3-B sponsored motif (PR 4, 2026-05-07)
import SponsorStore from './SponsorStore';
import SponsoredCampaignStore from './SponsoredCampaignStore';
import SponsoredMotifStore from './SponsoredMotifStore';
// T3-B PR 4 (2026-05-12): tier preset / template set / template motif catalog (read-only)
import TierCatalogStore from './TierCatalogStore';
// Coupon management redesign (Phase 2 PR 4, 2026-05-15)
import CouponTemplateStore from './CouponTemplateStore';

export default class RootStore {
    modalStore: ModalStore;
    apiStore: ApiStore;
    uiStore: UIStore;
    authStore: AuthStore;
    userStore: UserStore;
    itemStore: ItemStore;
    settingStore: SettingStore;
    libraryStore: LibraryStore;
    landmarkStore: LandmarkStore;
    landmarkNeighborhoodsStore: LandmarkNeighborhoodsStore;
    businessDashboardStore: BusinessDashboardStore;
    omikujiTextStore: OmikujiTextStore;
    userEventsAdminStore: UserEventsAdminStore;
    // T3-B sponsored motif (PR 4, 2026-05-07)
    sponsorStore: SponsorStore;
    sponsoredCampaignStore: SponsoredCampaignStore;
    sponsoredMotifStore: SponsoredMotifStore;
    // T3-B PR 4 (2026-05-12): tier preset / template set / template motif catalog (read-only)
    tierCatalogStore: TierCatalogStore;
    // Coupon management redesign (Phase 2 PR 4, 2026-05-15)
    couponTemplateStore: CouponTemplateStore;

    constructor() {
        makeObservable(this, {
            clearAllStore: action.bound
        });
        this.modalStore = new ModalStore();
        this.apiStore = new ApiStore(this);
        this.uiStore = new UIStore(this);
        this.authStore = new AuthStore(this);
        this.userStore = new UserStore(this);
        this.itemStore = new ItemStore(this);
        this.settingStore = new SettingStore(this);
        this.libraryStore = new LibraryStore(this);
        this.landmarkStore = new LandmarkStore(this);
        this.landmarkNeighborhoodsStore = new LandmarkNeighborhoodsStore(this);
        this.businessDashboardStore = new BusinessDashboardStore(this);
        this.omikujiTextStore = new OmikujiTextStore(this);
        this.userEventsAdminStore = new UserEventsAdminStore(this);
        // T3-B sponsored motif (PR 4, 2026-05-07)
        this.sponsorStore = new SponsorStore(this);
        this.sponsoredCampaignStore = new SponsoredCampaignStore(this);
        this.sponsoredMotifStore = new SponsoredMotifStore(this);
        // T3-B PR 4 (2026-05-12): tier preset / template set / template motif catalog (read-only)
        this.tierCatalogStore = new TierCatalogStore(this);
        // Coupon management redesign (Phase 2 PR 4, 2026-05-15)
        this.couponTemplateStore = new CouponTemplateStore(this);
    }

    clearAllStore() {
        this.userStore.clean();
        this.itemStore.clean();
        this.itemStore.clean();
        this.libraryStore.clean();
        this.landmarkStore.clean();
        this.businessDashboardStore.clean();
        this.omikujiTextStore.clean();
        this.userEventsAdminStore.clean();
        // T3-B sponsored motif (PR 4, 2026-05-07)
        this.sponsorStore.clean();
        this.sponsoredCampaignStore.clean();
        this.sponsoredMotifStore.clean();
        // T3-B PR 4 (2026-05-12)
        this.tierCatalogStore.clean();
    }
}
